export { default as SettingsComponent } from './Settings'
